import { queryFilter, type RowFilter } from '../domain/rowFilter.js';
import { useTRPC } from '../utils/trpc.js';
import { CURSOR_PAGING, PAGE_SIZE, usePagedRows } from './usePagedRows.js';

/** The Configs page's rows, 50 at a time — `useStudioRows`' shape over `configs.list`. */
export const useConfigRows = (filter: RowFilter) => {
    const trpc = useTRPC();
    return usePagedRows(
        trpc.configs.list.infiniteQueryOptions({ limit: PAGE_SIZE, ...queryFilter(filter) }, CURSOR_PAGING),
    );
};
